import PageViewer from "@/components/PageViewer";
import PERMISSIONS from "@/common/permissions-lib";

export default {
	path: "/MOT",
	meta: {
		breadcrumb: "TFR MOT",
		authorizedRoles: [
			PERMISSIONS.MOT_EDIT,
			PERMISSIONS.MOT_VIEW,
			PERMISSIONS.MOT_APPROVE
		]
	},
	component: PageViewer,
	props: { pageTransition: "none" },
	children: [
		{
			path: "/MOT",
			name: "TFR MOT",
			props: { pageTransition: "none" },
			component: () =>
				import(/* webpackChunkName: "MOT" */ "@/views/MOT/MOTMain")
		},
		{
			path: "/MOT/:motId?",
			name: "MOT.bymotId",
			props: route => ({ motId: route.params.motId }),
			meta: {
				breadcrumb() {
					return `${this.$route.params.motId}`;
				}
			},
			component: () =>
				import(/* webpackChunkName: "MOT.motId" */ "@/views/MOT/MOTDisplay")
		},
		{
			path: "/MOT/:rulesetId?",
			name: "MOT.byrulesetId",
			props: route => ({ rulesetId: route.params.motId }),
			meta: {
				breadcrumb() {
					return `rulesetId: ${this.$route.params.motId}`;
				}
			},
			component: () =>
				import(/* webpackChunkName: "MOT.motId" */ "@/views/MOT/MOTDisplay")
		},
		{
			path: "/MOT/:projectId?",
			name: "MOT.byprojectId",
			props: route => {
				return {
					projectId: route.params.projectId
				};
			},
			meta: {
				breadcrumb() {
					return (
						this.$mhi.replaceLabel("Project") +
						`Id:` +
						this.$route.params.projectId
					);
				}
			},
			component: () =>
				import(/* webpackChunkName: "MOT.motId" */ "@/views/MOT/MOTMain")
		}
	]
};
